export default __webpack_public_path__ + "static/media/arug_02-1.02efd341.jpg";